import { BottomBar, Header, Menu, PageTitle } from '@components';
import { BottomBarProvider } from '@contexts/BottomBarContext';
import { getSignature } from '@features/auth/auth.slice';
import { useGetMeMutation } from '@services';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import './AuthentifiedLayout.scss';

export const AuthentifiedLayout = () => {
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const location = useLocation();
    const signature = useSelector(getSignature);

    const [getMe] = useGetMeMutation();

    useEffect(() => {
        getMe();
    }, [location, getMe]);

    if (!signature && location.pathname !== '/signature/update') {
        return <Navigate to="/signature" replace />;
    }

    return (
        <BottomBarProvider>
            <div className="authentified-layout">
                <Header>
                    <PageTitle />
                </Header>
                <div className="rendered-page">
                    <Outlet />
                </div>
                <BottomBar setShowMenu={setShowMenu} showMenu={showMenu} />
                <Menu showMenu={showMenu} />
            </div>
        </BottomBarProvider>
    );
};

export default AuthentifiedLayout;
